<template>
    <van-swipe-cell :on-close="onClose">
        <div class="other-comment-item" @click="clickItem(commentData)">
            <p>
                <span class="other-ci-title">{{commentData.title}}</span>
                <i class="iconfont icon-bianji layout-glt-icon" @click.stop='clickEdit(commentData)'></i>
            </p>
            <p>
                <span class="other-ci-time">{{commentData.timeText}}</span>
            </p>
        </div>
        <template slot="right">
            <div class="com-record-delete other-ci-delete">删除</div>
        </template>
    </van-swipe-cell>
</template>

<script>
export default {
    name: 'CommentOtherItem',
    props: ['commentData', 'itemFunc', 'editFunc'],
    methods: {
        // 查看
        clickItem(data) {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc(data)
            }
        },
        // 编辑
        clickEdit(data) {
            if(this.editFunc && typeof(this.editFunc) == 'function') {
                this.editFunc(data)
            }
        },
        // 删除
        onClose(clickPosition, instance) {
            switch (clickPosition) {
                case 'cell':
                case 'outside':
                    instance.close();
                    break;
                case 'right':
                    this.$dialog.confirm({
                        message: '确定要删除这一条记录吗？'
                    }).then(() => {
                        // on confirm
                        console.log('deeeeeeelte', this.commentData)
                        this.$store.dispatch('othercomment/deleteOtherPiPanData', this.commentData.id);
                        // this.$store.dispatch('record/deleteRecordData', this.recordData.id);
                    }).catch(() => {
                        // on cancel
                        instance.close();
                    }); 
                break;
            }
        }
    }
}
</script>